/* Ancona Pass 19 — Cart continuity: Move to Saved (ancona-cart-save.js)
   Adds an explicit "Move to saved" control to each cart line (drawer + cart
   page). On use it (1) identifies the exact line by VARIANT IDENTITY against a
   freshly-fetched cart.js (never a stale positional index), (2) saves it to the
   SAME Saved Pieces store as Pass 12 (ancona:v1:saved, cap 24, identical
   {h,u,t,p,i,ts} shape), (3) confirms the local save, (4) triggers Dawn's native
   Ajax remove, then (5) CONFIRMS the line is actually gone (polling cart.js by
   line key) before announcing success and restoring focus. Any failure leaves
   the cart unchanged. No cart/checkout token is stored, no network write beyond
   the native cart, no account-sync claim. The header Saved hub refreshes via the
   shared ancona:saved_add CustomEvent (Pass 13 launch.js listens on document).
   Moves are serialized (one at a time) so concurrent removals can never reindex
   the wrong line. Feature flag: this <script> tag's data-ancona-cart attribute
   (token "save-later"). Absent -> on; empty string -> off. Revert: remove the
   two data-ancona-cart lines in layout/theme.liquid + this file + the CSS. */
(function () {
  'use strict';
  if (window.__anconaCartSave) return;
  window.__anconaCartSave = true;

  var script = document.currentScript;
  var flagAttr = script ? script.getAttribute('data-ancona-cart') : null;
  var FLAGS = (flagAttr == null ? 'save-later' : flagAttr).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  if (FLAGS.indexOf('save-later') === -1) return;

  var LS = null;
  try { LS = window.localStorage; LS.setItem('ancona:v1:t', '1'); LS.removeItem('ancona:v1:t'); } catch (e) { LS = null; }
  if (!LS) return; /* feature depends on the Saved store; fail silently otherwise */

  var SAVED_KEY = 'ancona:v1:saved'; /* owned by Pass 12 innovation.js — same shape + cap 24 */
  function savedList() {
    try {
      var v = JSON.parse(LS.getItem(SAVED_KEY));
      return Array.isArray(v) ? v.filter(function (x) { return x && typeof x.h === 'string' && typeof x.u === 'string'; }) : [];
    } catch (e) { try { LS.removeItem(SAVED_KEY); } catch (_) {} return []; }
  }
  function savedWrite(list) { try { LS.setItem(SAVED_KEY, JSON.stringify(list.slice(0, 24))); return true; } catch (e) { return false; } }
  function savedHas(h) { return savedList().some(function (x) { return x.h === h; }); }

  /* Locale/market-safe: Shopify.routes.root always ends with '/'. Normalise to a
     single separator so /cart.js resolves absolutely (default AND /{locale}/). */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function rootUrl(path) { return root.replace(/\/$/, '') + '/' + String(path).replace(/^\//, ''); }

  var live = null;
  function ensureLive() {
    if (live || !document.body) return live;
    live = document.createElement('div');
    live.className = 'ancona-visually-hidden'; /* utility defined in ancona-innovation.css (global) */
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('role', 'status');
    document.body.appendChild(live);
    return live;
  }
  function announce(msg) {
    try { var l = ensureLive(); if (!l) return; l.textContent = ''; window.setTimeout(function () { l.textContent = msg; }, 30); } catch (e) {}
  }

  function track(ev, payload) {
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(Object.assign({ event: 'ancona:' + ev }, payload || {}));
      document.dispatchEvent(new CustomEvent('ancona:' + ev, { detail: payload || {} }));
    } catch (e) { /* analytics/eventing must never break the cart */ }
  }

  var HEART = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="M12 21s-7-4.35-9.5-8.5C1 9 2.5 5.5 6 5.5c2 0 3.2 1.2 4 2.3.8-1.1 2-2.3 4-2.3 3.5 0 5 3.5 3.5 7C19 16.65 12 21 12 21z"/></svg>';

  function priceFromRow(row) {
    var el = row.querySelector('.cart-item__final-price') || row.querySelector('.cart-item__totals .price') || row.querySelector('.cart-item__price-wrapper .price');
    var txt = el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
    return txt.slice(0, 24);
  }

  /* Read the line's identity from the DOM row (Dawn's name link href = product
     url incl. ?variant=). Identity, not position, is what we trust. */
  function rowIdentity(row) {
    var a = row.querySelector('.cart-item__name') || row.querySelector('a[href*="/products/"]');
    var href = a ? (a.getAttribute('href') || '') : '';
    var hm = /\/products\/([a-z0-9][a-z0-9-]*)/i.exec(href);
    var vm = /[?&]variant=(\d+)/.exec(href);
    return { handle: hm ? hm[1] : '', variant: vm ? vm[1] : '' };
  }

  function nativeRemove(row) {
    var rb = row.querySelector('cart-remove-button a, cart-remove-button button');
    if (rb && rb.click) { rb.click(); return true; }
    return false;
  }

  /* Poll cart.js until the line key is gone (removal confirmed) or timeout. */
  function confirmRemoved(key) {
    var tries = 0;
    return new Promise(function (resolve) {
      function chk() {
        fetch(rootUrl('/cart.js'), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            var present = cart && cart.items && cart.items.some(function (x) { return x.key === key; });
            if (!present) return resolve(true);
            if (++tries >= 8) return resolve(false);
            window.setTimeout(chk, 300);
          })['catch'](function () { resolve(false); });
      }
      window.setTimeout(chk, 250);
    });
  }

  /* After a confirmed removal Dawn has re-rendered; keep keyboard focus inside the
     cart rather than letting it fall to <body>. */
  function restoreFocus(container) {
    try {
      var ae = document.activeElement;
      if (ae && ae !== document.body && container.contains(ae)) return; /* focus already sensible */
      var next = container.querySelector('.ancona-movetosave') ||
        container.querySelector('cart-remove-button a, cart-remove-button button') ||
        document.querySelector('#CartDrawer .drawer__close, #cart .cart__checkout-button, #CartDrawer-Checkout, .cart__checkout-button') ||
        container.querySelector('a[href]');
      if (next && next.focus) next.focus();
    } catch (e) {}
  }

  var moving = false; /* module-level serialization: one move at a time */

  function onMove(btn, container) {
    if (moving) return;
    var row = btn.closest('.cart-item');
    if (!row) return;
    var idxEl = row.querySelector('cart-remove-button[data-index]');
    var index = idxEl ? parseInt(idxEl.getAttribute('data-index'), 10) : NaN;
    if (!index || index < 1) { announce('Could not move this piece. Your cart is unchanged.'); return; }
    var ident = rowIdentity(row);
    if (!ident.handle) { announce('Could not move this piece. Your cart is unchanged.'); return; }
    moving = true; btn.dataset.busy = '1';
    var priceStr = priceFromRow(row);
    var lineKey = null;
    fetch(rootUrl('/cart.js'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items[index - 1]) throw new Error('no-item');
        var it = cart.items[index - 1];
        /* Drift guard: the positional line must still be the SAME product/variant
           the shopper clicked. If the cart changed (e.g. another tab), abort — never
           save or remove the wrong piece. */
        if (String(it.handle) !== ident.handle || (ident.variant && String(it.variant_id) !== ident.variant)) throw new Error('drift');
        var handle = it.handle;
        if (!handle || typeof handle !== 'string') throw new Error('no-handle');
        lineKey = it.key;
        var img = (it.featured_image && it.featured_image.url) || it.image || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        if (img) img += (img.indexOf('?') === -1 ? '?width=128' : '&width=128');
        /* Pass 20 exact-variant continuity: keep the selected variant in the saved
           link (canonical path built from public handle + numeric variant id). */
        var vid = it.variant_id ? String(it.variant_id).replace(/[^0-9]/g, '') : '';
        var url = '/products/' + handle + (vid ? ('?variant=' + vid) : '');
        /* SAVE FIRST — never remove until the local save is confirmed. */
        if (!savedHas(handle)) {
          var list = savedList();
          list.unshift({ h: handle, u: url, t: String(it.product_title || it.title || '').slice(0, 80), p: priceStr, i: img, ts: Date.now() });
          if (!savedWrite(list)) throw new Error('save-failed');
        }
        if (!savedHas(handle)) throw new Error('save-unconfirmed');
        track('saved_add', { handle: handle, source: 'cart' });
        /* Trigger Dawn's own Ajax remove, then CONFIRM the line is gone. */
        if (!nativeRemove(row)) throw new Error('remove-unavailable');
        return confirmRemoved(lineKey);
      })
      .then(function (removed) {
        moving = false; btn.dataset.busy = '';
        if (removed) { announce('Moved to your saved pieces.'); restoreFocus(container || document.body); }
        else announce('Saved in this browser. The piece is still in your cart.');
      })
      ['catch'](function (err) {
        moving = false; btn.dataset.busy = '';
        var m = err && err.message;
        if (m === 'drift') announce('Your cart changed. Please try again.');
        else if (m === 'save-failed' || m === 'save-unconfirmed') announce('Saving is unavailable in this browser. Your cart is unchanged.');
        else if (m === 'remove-unavailable') announce('Saved in this browser. Please remove it from the cart manually.');
        else announce('Could not move this piece. Your cart is unchanged.');
      });
  }

  function inject(container) {
    var rows = container.querySelectorAll('.cart-item');
    Array.prototype.forEach.call(rows, function (row) {
      if (row.dataset.anconaSaveWired) return;
      if (!row.querySelector('cart-remove-button[data-index]')) return; /* only real line items */
      row.dataset.anconaSaveWired = '1';
      var host = row.querySelector('.cart-item__quantity') || row.querySelector('.cart-item__details') || row;
      var nameEl = row.querySelector('.cart-item__name');
      var name = nameEl ? (nameEl.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80) : '';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ancona-movetosave';
      btn.setAttribute('aria-label', name ? ('Move ' + name + ' to your saved pieces') : 'Move to your saved pieces');
      btn.innerHTML = HEART + '<span class="ancona-movetosave__label" aria-hidden="true">Move to saved</span>';
      btn.addEventListener('click', function () { onMove(btn, container); });
      host.appendChild(btn);
    });
  }

  /* Scoped observer per cart container: Dawn re-renders line items on every cart
     mutation, wiping injected buttons — re-inject after each render. Disconnect
     during injection so our own DOM writes never re-trigger the observer. */
  function observe(container) {
    if (!container || container.__anconaSaveObs) return;
    container.__anconaSaveObs = true;
    var mo = null;
    function run() {
      if (mo) mo.disconnect();
      try { inject(container); } catch (e) {}
      if (mo) { try { mo.observe(container, { childList: true, subtree: true }); } catch (e) {} }
    }
    try { mo = new MutationObserver(run); } catch (e) { mo = null; }
    run();
  }

  function scan() {
    ensureLive();
    var drawer = document.getElementById('CartDrawer-CartItems') || document.querySelector('cart-drawer .js-contents');
    var page = document.getElementById('main-cart-items') || document.querySelector('cart-items');
    if (drawer) observe(drawer);
    if (page) observe(page);
    if (!drawer && !page) inject(document.body || document.documentElement);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  /* Theme editor: re-scan on section (re)load. Registered ONCE (observe() is idempotent). */
  document.addEventListener('shopify:section:load', scan);
})();
